export const defaultScrollBarStyles = {
	// Webkit (Chrome, Safari, Edge)
	"&::-webkit-scrollbar": {
		width: "8px", // Thin scrollbar
	},
	"&::-webkit-scrollbar-track": {
		backgroundColor: "#f1f1f1", // Light gray track
		borderRadius: "4px",
	},
	"&::-webkit-scrollbar-thumb": {
		backgroundColor: "#888", // Medium gray thumb
		borderRadius: "4px",
		"&:hover": {
			backgroundColor: "#555", // Darker gray on hover
		},
	},
	// Firefox
	scrollbarWidth: "thin", // Thin scrollbar
	scrollbarColor: "#888 #f1f1f1", // Thumb color, track color
};
